import { render, staticRenderFns } from "./video-player-youtube.vue?vue&type=template&id=636e7a00&lang=pug"
import script from "./video-player-youtube.vue?vue&type=script&lang=js"
export * from "./video-player-youtube.vue?vue&type=script&lang=js"
import style0 from "./video-player-youtube.vue?vue&type=style&index=0&id=636e7a00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports